import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MainCard from "components/MainCard";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const EquipmentRightTopTabList = ({equipment, measurementLogsLatest, equipmentAlerts, equipmentComponents, componentId, equipmentPartsByComponentId, hasControlData, hasTimelineData, isPannelLoaded=true, type='type1'}) => {
    const { t } = useTranslation();
    // const isKorea = process.env.REACT_APP_TIMEZONE === 'Asia/Seoul';
    
    const [isPannelView, setIsPannelView] = useState(false);
    // const [isElevatorView, setIsElevatorView] = useState(false);
    const [pannelBgColor, setPannelBgColor] = useState('unset');
    // const [elevatorBgColor, seElevatorBgColor] = useState('unset');

    const didInitRef = useRef(false);

    useEffect(()=>{
        if (didInitRef.current || !isPannelLoaded) return;
        if (type === 'type1') {
            // if (!equipment?.latestEquipmentOp) {
            //     if (equipmentComponents?.length > 0) {
            //         equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
            //     }
            //     didInitRef.current = true;
            //     return;
            // }
            didInitRef.current = true;
        } else {
            // 데이터가 아직 로딩 중(없음)인 상태 체크
            const isNoData = measurementLogsLatest?.length <= 0 && 
                !equipment?.latestEquipmentOp && 
                (equipmentAlerts?.length === 0 && !hasControlData && !hasTimelineData);
            if (isNoData) {
                if (type === 'type1') {
                    if (equipmentComponents?.length > 0) {
                        equipmentPartsByComponentId(equipmentComponents[0].id); // 첫번째 구성부
                    }
                } else {
                    equipmentPartsByComponentId(-3);    // 사진/도면
                }
                didInitRef.current = true;
                return;
            }

// console.log(measurementLogsLatest?.length)
            if (measurementLogsLatest?.length <= 0) {
                equipmentPartsByComponentId(-1);    // 운전/진단
                didInitRef.current = true;
            }
        }
    }, [
        type, 
        isPannelLoaded,
        measurementLogsLatest, 
        equipment?.latestEquipmentOp, 
        equipmentAlerts, 
        hasControlData, 
        hasTimelineData, 
        equipmentComponents
    ])

    useEffect(()=>{
        // if (equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') {
        // console.log(equipmentAlerts?.length)
        if (equipment?.latestEquipmentOp || equipmentAlerts?.length > 0 || hasControlData || hasTimelineData) {
            setIsPannelView(true);
            if (equipment?.latestEquipmentOp?.controlPanelCode?.alertYn === 'Y') {
                if (componentId===-1)
                    setPannelBgColor('3px solid #ed1c24');
                else
                    setPannelBgColor('1px solid #0061d0');
                    // setPannelBgColor('#000');
            } else {
                if (componentId===-1)
                    setPannelBgColor('3px solid #0061d0');
                else
                    setPannelBgColor('1px solid #0061d0');
                    // setPannelBgColor('#000');
            }
        }
    },[isPannelView, equipmentAlerts, componentId, hasControlData, hasTimelineData])

    // useEffect(()=>{
    //     if (isKorea && (equipment?.equipmentCtgr.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr.parent?.parent?.code === 'ES' 
    //         || equipment?.equipmentCtgr.code.startsWith('GEARED.') || equipment?.equipmentCtgr.code.startsWith('GEARLESS')
    //         || equipment?.equipmentCtgr.code.startsWith('DOUBLE.') || equipment?.equipmentCtgr.code.startsWith('SINGLE.'))) {

    //         // setIsElevatorView(true);
            
    //         // if (componentId===-4)
    //         //     seElevatorBgColor('3px solid #0061d0');
    //         // else
    //         //     seElevatorBgColor('1px solid #0061d0');
    //     }
    // },[isKorea, equipment, componentId])
    // },[isElevatorView, isKorea, equipment, componentId])
    
    return (
        <div className='alert_phrase' style={{marginBottom:"10px"}}>
            <MainCard content={false} className="mobile_top">
            <TableContainer>
                <Table sx={{ minWidth: 500 }} aria-label="simple table">
                <TableBody>
                    <TableRow className='statustab_bg'>
                        <TableCell style={{textAlign:"left"}}>
                        <div style={{padding:"10px 20px"}}>
                        {(type === 'type1' || measurementLogsLatest?.length > 0) &&
                            <p className="statustab0" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${componentId === -2 ? "3px solid #0061d0": "1px solid #0061d0"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-2)}}>{t('message.common.tabTitle.status.status')}</p>
                        }
                        {isPannelView && 
                            <p className="statustab1" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${pannelBgColor}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-1)}}>{t('message.common.chip.panel')}</p>
                        }
                        {type === 'type2' &&
                            <p className="statustab4" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${componentId === -3 ? "3px solid #0061d0": "1px solid #0061d0"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-3)}}>{t('message.common.tabTitle.picture.data')}</p>
                        }
                        {equipmentComponents && equipmentComponents.map(function(item, i) {
                            let componentName = item.name;
                            let bgColor = "3px solid #0061d0";
                            let defaultBgColor = "1px solid #0061d0";
                            if (item.countFaultCodesOfAlertY && item.countFaultCodesOfAlertY > 0) {
                                bgColor = "3px solid #ed1c24";
                                defaultBgColor = "1px solid #ed1c24";
                            } else if (item.countFaultCodesOfAlertN && item.countFaultCodesOfAlertN > 0) {
                                bgColor = "3px solid #e5a846";
                                defaultBgColor = "1px solid #e5a846";
                            } else {
                                bgColor = "3px solid #0061d0";
                                defaultBgColor = "1px solid #0061d0";
                            }

                            if (item.status === 'NORMAL') {
                                componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';//유효
                                // bgColor = "#5b9bd5";
                            } else if (item.status === 'ALERT') {
                                componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';//임박
                                // bgColor = "#ff0000";
                            } else if (item.status === 'EXPIRED') {
                                componentName += '<span class="instate3">'+t('message.common.text.lapse')+'</span>';//경과
                                // bgColor = "#2c2c2c";
                            }
                            const isSelected = componentId == item.id;
                            return (
                                <p className={isSelected ? "statustab2":"statustab3"} key={i} style={{cursor:"pointer", display:"inline-block", padding:"3px 5px", margin:"2px 10px 2px 0", borderRadius:"100px", border:isSelected ? bgColor : defaultBgColor, backgroundColor:"#000", color:"#fff"}} onClick={()=>{equipmentPartsByComponentId(item.id)}} dangerouslySetInnerHTML={ {__html: componentName} }></p>
                            )
                        }) }
                        {/* {isElevatorView && 
                            <p className="elevatorInfo" style={{cursor:"pointer", display:"inline-block", padding:"8px 9px", margin:"2px 10px 2px 0", borderRadius:"100px", border:`${elevatorBgColor}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{equipmentPartsByComponentId(-4)}}>{t('message.common.chip.inspection.testing')}</p>
                        } */}
                        </div>
                        </TableCell>
                    </TableRow>
                </TableBody>
                </Table>
            </TableContainer>
            </MainCard>
        </div>
    )
}

export default EquipmentRightTopTabList;